import axios from "axios";
import { getHeadersConfig } from "../utils/config";
import { joinURLs } from "../utils/urlUtil";
import { ClinkNotesResponseDto, ResponseStatus } from "../utils/types";
import ErrorHandler from "../utils/ErrorHandler";

let addCLinkNoteAbortController = new AbortController();
let getCLinkNotesAbortController = new AbortController();

export const ClinkNotes = {
  addClinkNote: async (clinkId:string, message:string) => {
    if (addCLinkNoteAbortController) addCLinkNoteAbortController.abort();
    addCLinkNoteAbortController = new AbortController();
  
    const url = joinURLs("api/clink/" + clinkId + "/notes", process.env.REACT_APP_JUPITER_API_BASE_URL);
    try {
      const response:any = await axios({ url: url, method: "post", params: { message }, ...getHeadersConfig(), signal: addCLinkNoteAbortController.signal });

      return response.data;
    } catch (error:any) {
      // handle error
      console.log('error', error);
      return { error };
    }
  }, 
  getClinkNotes: async (clinkId:string, setClinkNotesResponseDto:(clinkNotesResponseDto:ClinkNotesResponseDto) => void) => {
    if (getCLinkNotesAbortController) getCLinkNotesAbortController.abort();
    getCLinkNotesAbortController = new AbortController();

    const responseDto:ClinkNotesResponseDto = {
      status: ResponseStatus.LOADING, 
      error: null,
      clinkNotes: []
    };
    setClinkNotesResponseDto(responseDto);

    const url = joinURLs("api/clink/" + clinkId + "/notes/", process.env.REACT_APP_JUPITER_API_BASE_URL);
    try {
      const response:any = await axios.get(url, {...getHeadersConfig(), signal: getCLinkNotesAbortController.signal });

      const responseDto:ClinkNotesResponseDto = {
        status: ResponseStatus.OK, 
        error: null,
        clinkNotes: response.data
      };
      setClinkNotesResponseDto(responseDto);
    } catch (error:any) {
      // handle error

      if (!axios.isCancel(error)) {
        const isLoggedOut:boolean = ErrorHandler.handleLoggedOutError(error);
        if (!isLoggedOut){
          const responseDto: ClinkNotesResponseDto = {
            status: ResponseStatus.ERROR, 
            error: error?.response?.data?.errorMessage,           
            clinkNotes: []
          };
          setClinkNotesResponseDto(responseDto);
        }
      }
    }
  }
}